<template>
    <div ref="aqui">
        <vs-table :key="componentKey">
            <template #thead>
            <vs-tr v-if="agrupar">
                <vs-th>
                    <h5 v-if="agrupar == 'codigo_sesion'">Código sesión</h5>
                    <h5 v-if="agrupar == 'docente'">Docente</h5>
                    <h5 v-if="agrupar == 'alumno'">Alumno</h5>
                    <h5 v-if="agrupar == 'programa'">Programa</h5>
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in informacion"
                class="divisionLineas"
            >
                <vs-td>
                    <h5>{{tr.nombre}}</h5>
                </vs-td>

                <template #expand>
                    <div class="con-content">
                        <div>
                            <vs-button
                                icon
                                color="danger"
                                flat
                                class="ml-auto"
                                @click="activeEliminarMasivo =! activeEliminarMasivo; rowMasivo = selected"
                            >
                                <i class="far fa-trash-alt"></i> Eliminar registros
                            </vs-button>
                            <vs-table class="mt-1" v-model="selected">
                                <template #thead>
                                <vs-tr>
                                    <vs-th>
                                    <vs-checkbox
                                        :indeterminate="selected.length == tr.info.length" v-model="allCheck"
                                        @change="selected = $vs.checkAll(selected, tr.info)"
                                    />
                                    </vs-th>
                                    <vs-th>
                                        Alumno
                                    </vs-th>
                                    <vs-th>
                                        Profesor
                                    </vs-th>
                                    <vs-th>
                                        Acción
                                    </vs-th>
                                </vs-tr>
                                </template>
                                <template #tbody>
                                <vs-tr
                                    :key="i"
                                    v-for="(tr, i) in tr.info"
                                    :data="tr"
                                    :is-selected="!!selected.includes(tr)"
                                    class="divisionLineas"
                                >
                                    <vs-td checkbox>
                                        <vs-checkbox :val="tr" v-model="selected" />
                                    </vs-td>
                                    <vs-td>
                                        <div class="estatus-alumno" :class="coloresEstatus(tr.estatus_registro_academico)" v-if="tr.estatus_registro_academico">
                                            <small><strong>{{tr.estatus_registro_academico}}</strong></small>
                                        </div>
                                        <p class="mt-2 mb-0"><strong>{{tr.alumno}}</strong></p>
                                        <p class="mb-2 text-uppercase"><small class="text-uppercase">Matrícula</small> {{tr.matricula}}</p>
                                    </vs-td>
                                    <vs-td>
                                        <p class="mt-2 mb-0"><strong>{{tr.docente}}</strong></p>
                                        <md-chip class="mini-chip col-blue mx-0 mb-2" ><small class="text-uppercase">Código de sesión</small> <strong>{{tr.codigo_sesion}}</strong></md-chip>
                                    </vs-td>
                                    <vs-td>
                                        <vs-button
                                            class="m-auto"
                                            icon
                                            color="danger"
                                            flat
                                            @click="activeEliminar =! activeEliminar; row = tr"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </vs-button>
                                    </vs-td>
                                </vs-tr>

                                </template>
                            </vs-table>
                        </div>
                    </div>
                </template>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>

         </vs-table>

        <vs-dialog prevent-close v-model="activeEliminar">
            <template #header>
            <h4 class="not-margin">
                Eliminar registro
            </h4>
            </template>


            <div class="con-form">
                <p><strong><i>El registro se eliminará permanentemente. ¿Esta seguro de eliminarlo?</i></strong></p>
                <vs-row>
                    <vs-col sm="12" lg="6">
                        <p class="mb-2 text-uppercase"><small class="text-uppercase">Alumno</small><strong> {{row.alumno}} </strong></p>
                        <p class="mb-2 text-uppercase"><small class="text-uppercase">Matrícula</small><strong> {{row.matricula}} </strong></p>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <p class="mb-0"><strong>{{row.docente}}</strong></p>
                        <md-chip class="mini-chip col-blue mx-0 mb-2" ><small class="text-uppercase">Código de sesión</small> <strong>{{row.codigo_sesion}}</strong></md-chip>
                    </vs-col>
                </vs-row>
            </div>

            <template #footer>
                <vs-row>
                    <vs-col sm="12" lg="6">
                        <vs-button
                            danger
                            flat
                            @click="activeEliminar = false"
                        >
                            Cancelar
                        </vs-button>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <vs-button
                            success
                            class="ml-auto"
                            @click="getEliminarGrupoAcademico(row)"
                        >
                            Aceptar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </template>
        </vs-dialog>
         
        <vs-dialog prevent-close v-model="activeEliminarMasivo">
            <template #header>
            <h4 class="not-margin">
                Eliminar los registros
            </h4>
            </template>


            <div class="con-form">
                <p><strong><i>Los registros se eliminarán permanentemente. ¿Esta seguro de hacerlo?</i></strong></p>
            </div>

            <template #footer>
                <vs-row>
                    <vs-col sm="12" lg="6">
                        <vs-button
                            danger
                            flat
                            @click="activeEliminar = false"
                        >
                            Cancelar
                        </vs-button>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <vs-button
                            success
                            class="ml-auto"
                            @click="getEliminarMasivoGrupoAcademico(row)"
                        >
                            Aceptar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
export default {
    props:[
        'users',
        'agrupar',
        'componentKey'
    ],
    data(){
        return{
            informacion: [],
            activeEliminar: false,
            activeEliminarMasivo: false,
            row: [],
            rowMasivo: [],
            allCheck: false,
            selected: [],
            estatusBaja: []
        }
    },
    created(){
        this.getEstatusAlumno()
    },
    methods: {
        getDays(dia){
            const dias = dia.split(',')
            const days = []
            dias.forEach(element =>{
                if(element == 'l'){
                    days.push('Lunes')
                }else if(element == 'm'){
                    days.push('Martes')
                }else if(element == 'mi'){
                    days.push('Miércoles')
                }else if(element == 'j'){
                    days.push('Jueves')
                }else if(element == 'v'){
                    days.push('Viernes')
                }else if(element == 's'){
                    days.push('Sabado')
                }else if(element == 'd'){
                    days.push('Domingo')
                }
            })
            return days.join(', ')
        },
        async getEstatusAlumno(){
            try{
                const params = {
                    type: 'baja'
                }
                const {data: response} = await reportes.getEstatusAlumno(params)
                response.map(r =>{
                    this.estatusBaja.push(r.status)
                })
            }catch(error){
                console.error(error)
            }
        },
        coloresEstatus(estatus){
            if(['Inscrito económico','Reactivación'].includes(estatus)){
                return 'col-green'
            }else if(['Congelado'].includes(estatus)){
                return 'col-yellow'
            }else if(this.estatusBaja.includes(estatus)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        getUsers(){
            const llaves = Object.keys(this.users).sort()
            const arreglo = []
            llaves.forEach(element => {
                let obj = {
                    nombre: element,
                    info: this.users[element]
                }
                arreglo.push(obj)
            })
            this.informacion = arreglo
            this.ocultar = true
        },
        async getEliminarGrupoAcademico(info){
            const loading = this.$vs.loading()
            try {
                const params = {
                    registro_academico_crn_id: info.registro_academico_crn_id,
                    ciclo_escolar_id: info.ciclo_escolar_id,
                    institucion_id: info.institucion_id,
                    registro_academico_id: info.registro_academico_id,
                    codigo_sesion_id: info.codigo_sesion_id,
                    persona_docente_id: info.persona_docente_id
                }
                const response = await reportes.getEliminarGrupoAcademico(params)
                loading.close()
                this.$emit('refreshTable')
                this.activeEliminar = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: response.data.message
                })
            }
            catch(error){
                loading.close()
                this.activeEliminar = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un problema',
                    text: error.response.data.message 
                })
            }
        },
        async getEliminarGrupoAcademico(info){
            const loading = this.$vs.loading()
            try {
                const params = {
                    registro_academico_crn_id: info.registro_academico_crn_id,
                    ciclo_escolar_id: info.ciclo_escolar_id,
                    institucion_id: info.institucion_id,
                    registro_academico_id: info.registro_academico_id,
                    codigo_sesion_id: info.codigo_sesion_id,
                    persona_docente_id: info.persona_docente_id
                }
                const response = await reportes.getEliminarGrupoAcademico(params)
                loading.close()
                this.$emit('refreshTable')
                this.activeEliminar = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: response.data.message
                })
            }
            catch(error){
                loading.close()
                this.activeEliminar = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un problema',
                    text: error.response.data.message 
                })
            }
        },
        async getEliminarMasivoGrupoAcademico(info){
            const loading = this.$vs.loading()
            let valor = 0
            const vue = this
            for(const element of this.selected) {
                valor += 1
                try {
                    const params = {
                        registro_academico_crn_id: element.registro_academico_crn_id,
                        ciclo_escolar_id: element.ciclo_escolar_id,
                        institucion_id: element.institucion_id,
                        registro_academico_id: element.registro_academico_id,
                        codigo_sesion_id: element.codigo_sesion_id,
                        persona_docente_id: element.persona_docente_id
                    }
                    const response = await reportes.getEliminarGrupoAcademico(params)
                    if(valor === vue.selected.length){
                        loading.close()
                        vue.$emit('refreshTable')
                        vue.activeEliminarMasivo = false
                        vue.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: null,
                            title: 'Operación éxitosa',
                            text: response.data.message
                        })
                    }
                }
                catch(error){
                    if(valor === vue.selected.length){
                        loading.close()
                        vue.activeEliminarMasivo = false
                        vue.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Hubo un problema',
                            text: error.response.data.message 
                        })
                    }
                }
            }
        },
        forceRerender() {
            this.componentKey += 1;
        }    
    },
    watch:{
        users(){
            this.informacion = []
            this.getUsers()
        }
    }
}
</script>

<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .divisionLineas:not(:last-child){
        border-bottom: 1px solid #E5E7E9; 
    }
    .divisionLineas{
        padding: 2% 0;
    }

    .borderBox{
        border: 1px solid #E5E7E9;
        border-radius: 7px;
        padding: 0.8rem;
        margin: 0.7rem 0;
    }
</style>